

























import { BannerInList, getBanners, deleteBanner } from '@/api/banner';
import { MessageBox } from 'element-ui';
import { Component, Vue } from 'vue-property-decorator';
import _get from 'lodash/get';

@Component({
  name: 'BannerList',
})
export default class BannerList extends Vue {
  private banners: BannerInList[] = [];
  private listLoading: boolean = false;
  private creating = false;

  private created() {
    return this.refresh();
  }

  private goDetailAt(i: number) {
    const name = this.banners[i]?.page?.name;
    const bannerName = this.banners[i]?.page?.bannerName;
    if (name) {
      return this.$router.push({
        name: 'BannerDetail',
        query: { name, bannerName },
      });
    }
  }

  private async deleteBannerAt(i: number) {
    const banner = this.banners[i];
    const confirmed = await MessageBox.confirm('删除后无法恢复，是否继续？', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'error',
    }).catch((e) => false);
    if (confirmed && banner) {
      try {
        await deleteBanner(banner._id);
      } catch (error) {
        this.$message.error(_get(error, 'data.message') || error.message || '删除失败');
      }
      await this.refresh();
    }
  }

  private async refresh() {
    this.listLoading = true;
    this.banners = await getBanners();
    this.listLoading = false;
  }
}
